module.exports = __webpack_public_path__ + "img/leaf3.3b1313b6.png";